import React from 'react';
import { useIntl } from 'react-intl';
import { maintenanceMessages } from 'azshared';
import AppCourtesyPage from 'src/components/courtesy-page/app-courtesy-page';

function MaintenancePage() {
  const { formatMessage } = useIntl();

  return (
    <AppCourtesyPage
      icon='tools'
      title={formatMessage(maintenanceMessages.title)}
      subtitle={formatMessage(maintenanceMessages.subtitle)}
      /* -- example of notes for courtesy page
      notes={[
        'Intervento programmato dal <strong>25/02/2026</strong> ore <strong>22:30</strong> al <strong>26/02/2026</strong> ore <strong>3:00</strong>',
        'Numero verde per assistenza: <a href="tel:04222245687">0422 2245687</a>'
      ]}
      */
    />
  );
}

export default MaintenancePage;
